<main [class]="'overflow-hidden ' + selectedTheme">
  <app-message-tape></app-message-tape>
  <router-outlet></router-outlet>
  <app-toast></app-toast>
  <app-confirm-dialog></app-confirm-dialog>
  <app-splash-screen [selectedTheme]="selectedTheme"></app-splash-screen>
  <app-offline-screen [isShow]="isShowOfflineScreen"></app-offline-screen>
  <app-version-update-screen [isShow]="isShowVersionUpdate"></app-version-update-screen>
</main>
